import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCcrnW0t6TyTP2TGEjQlV1a6xoku0YdQyE",
  authDomain: "pulsenote-7c329.firebaseapp.com",
  projectId: "pulsenote-7c329",
  storageBucket: "pulsenote-7c329.firebasestorage.app",
  messagingSenderId: "942567798196",
  appId: "1:942567798196:web:1514997f7f999fc2aa6ee1"
};

// Initialize Firebase and services
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);


try {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Persistence failed: Multiple tabs open');
    } else if (err.code === 'unimplemented') {
      console.warn('Persistence failed: Browser not supported');
    }
  });
} catch (e) {
  console.warn("Persistence initialization error:", e);
}

export const storage = getStorage(app);

// Always target the same region so callable paths stay consistent
const functionsInstance = getFunctions(app, "asia-south1");
// if (process.env.NODE_ENV === "development" && window.location.hostname === "localhost") {
//   connectFunctionsEmulator(functionsInstance, "localhost", 5001);
// }

export const cloudFunctions = functionsInstance;
